export default __webpack_public_path__ + "static/media/page-title-services-uz.e615e784.svg";